import {
  BLACKLIST_FETCH_REQUEST,
  BLACKLIST_FETCH_SUCCESS,
  BLACKLIST_FETCH_FAILURE,
  BLACKLIST_REMOVE_REQUEST,
  BLACKLIST_REMOVE_SUCCESS,
  BLACKLIST_REMOVE_FAILURE,
  BLACKLIST_SELECT_ITEM,
  BLACKLIST_CLEAR
} from './blacklistActions'

const INITIAL_STATE = {
  acoes: [],
  selecionada: null,
  loading: false,
  loaded: false,
  removing: false,
  removingId: null,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BLACKLIST_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case BLACKLIST_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        acoes: action.payload.acoes,
        selecionada: action.payload.selecionada
      }

    case BLACKLIST_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case BLACKLIST_REMOVE_REQUEST:
      return {
        ...state,
        removing: true,
        removingId: action.payload,
        error: null
      }

    case BLACKLIST_REMOVE_SUCCESS: {
      const acaoId = action.payload.acaoId
      const indiceAtual = state.acoes.findIndex(item => item.id === acaoId)
      const novasAcoes = state.acoes.filter(item => item.id !== acaoId)

      let novaSelecionada = state.selecionada

      if (state.selecionada?.id === acaoId) {
        if (novasAcoes.length === 0) {
          novaSelecionada = null
        } else if (indiceAtual >= 0 && indiceAtual < novasAcoes.length) {
          novaSelecionada = novasAcoes[indiceAtual]
        } else if (indiceAtual - 1 >= 0 && novasAcoes[indiceAtual - 1]) {
          novaSelecionada = novasAcoes[indiceAtual - 1]
        } else {
          novaSelecionada = novasAcoes[0]
        }
      }

      return {
        ...state,
        removing: false,
        removingId: null,
        error: null,
        acoes: novasAcoes,
        selecionada: novaSelecionada
      }
    }

    case BLACKLIST_REMOVE_FAILURE:
      return {
        ...state,
        removing: false,
        removingId: null,
        error: action.payload
      }

    case BLACKLIST_SELECT_ITEM:
      return {
        ...state,
        selecionada: action.payload
      }

    case BLACKLIST_CLEAR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}